<template>
    <main class="logout">
        <h1 class="logout__title">Sesja została zakończona</h1>
    </main>
</template>

<script>
export default {
    name: "Logout",
    beforeMount() {
        this.$store.commit("destroyUserToken");
        this.redirectTimeout = setTimeout(() => this.$router.push("/"), 5000);
    },
    beforeRouteLeave(to, from, next) {
		clearTimeout(this.redirectTimeout);
        next();
    },
};
</script>

<style lang="scss">
.logout {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    &__title {
        text-align: center;
    }
}
</style>